import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Card Lab — an isolated, auth-free design surface for the link tile.
 *
 * `LinkCard` is a self-contained COPY of the viewer's link post-it tile (the
 * card seen in the grid). It carries no data dependency — every instance is fed
 * plain props — so the markup and `card-lab.scss` can be reworked here without
 * touching the production `BlockBody` / `DataBlockTile`. Mounted at `/dev/card`.
 */
import React from "react";
import "./card-lab.scss";
/**
 * Soft post-it tint from a hue, copied from `postitTint` in `block-visuals.tsx`
 * (which derives the hue from a block id). Exposed as a plain hue here so cards
 * can be designed across the palette.
 */
function tint(hue) {
    return {
        background: `hsl(${hue} 65% 94%)`,
        color: `hsl(${hue} 35% 28%)`,
        borderColor: `hsl(${hue} 40% 82%)`,
    };
}
/** A copy of the viewer's link tile: tinted post-it card + caption row. */
const LinkCard = ({ title, description, host, time, hue }) => (_jsxs("div", { className: "card-lab__tile", children: [_jsxs("div", { className: "card-lab__frame", children: [_jsxs("div", { className: "card-lab__card", style: tint(hue), children: [_jsx("div", { className: "card-lab__card-title", children: title }), description ? _jsx("div", { className: "card-lab__card-desc", children: description }) : undefined, _jsx("div", { className: "card-lab__card-host", children: host })] }), _jsx("a", { className: "card-lab__open", href: `https://${host}`, target: "_blank", rel: "noreferrer", "aria-label": "Open link", children: "\u2192" })] }), _jsxs("div", { className: "card-lab__caption", children: [_jsx("span", { className: "card-lab__caption-name", children: title }), _jsx("span", { className: "card-lab__caption-by", children: time })] })] }));
/** A spread of cards to design against — the hero plus edge cases. */
const SAMPLES = [
    {
        title: "Homepage - Fragment Found",
        host: "fragmentfound.com",
        time: "3d",
        hue: 275,
    },
    {
        title: "A much longer title that needs to wrap across several lines to test vertical rhythm",
        host: "example.com",
        time: "1w",
        hue: 18,
    },
    {
        title: "With a description",
        description: "The description is hidden on the grid tile but available for the expanded card design.",
        host: "putty.inc",
        time: "now",
        hue: 145,
    },
    {
        title: "Short",
        host: "news.ycombinator.com",
        time: "5mo",
        hue: 205,
    },
];
export const CardLab = () => (_jsxs("div", { className: "card-lab", children: [_jsxs("header", { className: "card-lab__head", children: [_jsx("h1", { className: "card-lab__title-h", children: "Card Lab" }), _jsx("span", { className: "card-lab__path", children: "/dev/card \u00B7 link tile" })] }), _jsx("div", { className: "card-lab__stage", children: SAMPLES.map((s, i) => (_jsx(LinkCard, { ...s }, i))) })] }));
